// extracted by mini-css-extract-plugin
export var root = "Testimonial-module--root--3z-K7";
export var quote = "Testimonial-module--quote--1RfPj";
export var author = "Testimonial-module--author--B9EcA";